import { useScopedAppFlagStore } from '@frontend/scope';

export const useGetPreferenceBasedRequestFeatureFlagDetails = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isPreferenceBasedRequestEnabled = getFeatureFlagValue('schedule-air-preference-requests', 'ALL');

  return {
    isPreferenceBasedRequestEnabled,
  };
};
